// extracted by mini-css-extract-plugin
export default {"header1":"Header_header1__RWSm2","header":"Header_header__Lhnr8"};